<div class="modal-header">
  <h4 class="modal-title mb-1">{{ modalTitle() ?? "" | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closed.emit()"
  ></button>
</div>

<div class="modal-body" [class.modal-body--scrollable]="scrollableBody()">
  <ng-container
    *ngIf="mainContentTemplate() as template"
    [ngTemplateOutlet]="template"
  ></ng-container>
</div>

<div class="modal-footer">
  <ng-container *ngIf="secondaryActionTemplate() as template">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </ng-container>

  <ng-container>
    <ng-container
      *ngIf="primaryActionTemplate() as template"
      [ngTemplateOutlet]="template"
    ></ng-container>
  </ng-container>
</div>
